import CrownForm, {Response} from "./CrownForm";

// Show 'number meters required' field if selecting Metering
document
  .querySelector("#quote-service-required")
  ?.addEventListener("input", function () {
    const service = this.value;
    const numberMetersRequired = document.querySelector(
      "#quote-number-meters-required"
    );
    const numberMetersRequiredParent =
      numberMetersRequired?.closest<HTMLElement>(".form__field");

    if (!numberMetersRequiredParent || !numberMetersRequired) return;

    if (service === "Metering") {
      numberMetersRequired.removeAttribute("disabled");
      numberMetersRequiredParent.style.display = "flex";
    } else {
      numberMetersRequired.setAttribute("disabled", "disabled");
      numberMetersRequiredParent.style.display = "none";
    }
  });

// Quote form events
const formEl = document.querySelector<HTMLFormElement>("#quote-form");
if (formEl) {
  // Submit quote form
  new CrownForm({
    el: formEl,

    url: "/wp-content/themes/crownenergy/ajax/QuoteForm.php",

    success(response: Response) {
      const service = encodeURIComponent(response.form_data['service-required']);
      const customerType = encodeURIComponent(response.form_data['customer-type']);

      const destination = new URLSearchParams({
        'customer-type': customerType,
        service,
      });

      if (service === 'Metering') {
        const numberMetersRequired = encodeURIComponent(response.form_data['number-meters-required']);

        destination.append('number-meters-required', numberMetersRequired);
      }

      window.location.href = `/thank-you/?${destination.toString()}`;
    },
  });

  // Check if form has hit the bottom of the content
  const footer = document.querySelector("footer");
  const formContainer = document.querySelector(".quote-container");
  if (formContainer && footer) {
    new IntersectionObserver(
      (entries) => {
        formContainer.classList[entries[0].isIntersecting ? "add" : "remove"](
          "bottom__stuck"
        );
      },
      {
        rootMargin: "0px 0px -160px 0px",
      }
    ).observe(footer);
  }
}
